var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"textBox"},[_c('transition',{attrs:{"name":"slide"}},[_c('p',{key:_vm.text.id,staticClass:"text",on:{"mouseenter":_vm.mouseenter,"mouseleave":_vm.mouseleave}},[_vm._v(" "+_vm._s(_vm.text.val)+" ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }